/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import Paging from "./Paging";
import { qreq } from "../shared/qrequest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Alert from "./Alert";
import Auth from "../shared/Auth";
import { SidebarGlobal } from "./_SidebarGlobal";

class Facilities extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loaded: false,
            loading: true,
            pageCount: 0,
            page: props.params ? props.params.page ?? 1 : 1
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
        SidebarGlobal.setSubNav(<><div className="btn-group">
            <button type="button" className="btn btn-primary" onClick={() => this.props.navigate('/facility/new')}><FontAwesomeIcon icon={fa.faPlus} /> <span className="d-none d-md-inline"><L>New Facility</L></span></button>
            <button type="button" className="btn btn-primary" onClick={() => this.load()}><FontAwesomeIcon icon={fa.faRefresh} /> <span className="d-none d-md-inline"><L>Refresh</L></span></button>
        </div></>);
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.page !== this.props.params.page) {
            this.state.page = Number(this.props.params.page);
            this.setState({ query: this.state.query });
            this.load();
        }
    }

    load() {
        this.setState({ loading: true });
        qreq.get('/api/account/facility/list', j => {
            if (j.list)
                this.setState({ list: j.list, pageCount: j.pageCount });
            else if (j.errorCode !== 0)
                this.setState({ errorMessage: j.errorMessage });
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    render() {
        const header = (<h1><L>Facility List</L></h1>);
        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid">
            {header}
            {Auth.hasRole('account-manager') || Auth.hasRole('sales') ?
                <DataTable columns={[
                    { icon: 'Pencil', link: '/facility/edit/:id', tooltip: 'Edit Facility' },
                    { icon: 'Users', link: '/facility/view/:id/examination/list', tooltip: 'View Residents' },
                    { name: 'id', title: 'ID', link: '/facility/edit/:id', tooltip: 'Edit Facility' },
                    { name: 'name', title: 'Facility', link: '/facility/view/:id/examination/list', tooltip: 'View Residents' },
                    { name: 'status', title: 'Status' },
                    { name: 'createdDate', title: 'Created', format: 'datetime' }
                ]} data={this.state.list} totalCount={this.state.totalCount} loading={this.state.loading} onSort={this.onSort} filters={[
                    { name: 'status', title: 'Status', filter: 'Status', type: 'select', options: this.state.statusList },
                    { name: 'createdDate', title: 'Created Date', filter: 'CreatedDate', type: 'daterange' }
                ]} />
                : <DataTable columns={[
                    { icon: 'Users', link: '/facility/view/:id/examination/list', tooltip: 'View Residents' },
                    { name: 'name', title: 'Facility', link: '/facility/view/:id/examination/list', tooltip: 'View Residents' },
                    { name: 'status', title: 'Status' },
                    { name: 'createdDate', title: 'Created', format: 'datetime' }
                ]} data={this.state.list} totalCount={this.state.totalCount} loading={this.state.loading} onSort={this.onSort} filters={[
                    { name: 'status', title: 'Status', filter: 'Status', type: 'select', options: this.state.statusList },
                    { name: 'createdDate', title: 'Created Date', filter: 'CreatedDate', type: 'daterange' }
                ]} />}
            <div className="card-body">
                <Paging baseLoc="/facility/list/page/" pageCount={this.state.pageCount} currentPage={this.state.page} onPageClick={(e) => this.setState({ loading: true })} />
            </div>
        </div>;
    }
}

export default withParamsAndNavigate(Facilities);